function fmt(value, capitalize) {
  if (value == null || value === "") return null;
  const s = String(value);
  return capitalize ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

function field(label, value, opts = {}) {
  if (value == null || value === "") return null;
  return { label, value, ...opts };
}

function compactFields(entries) {
  return entries.filter(Boolean);
}

export function buildAccountDetailSections(account) {
  const sp = account.salesPipeline ?? {};
  const contact = account.contact ?? {};
  const sections = [];

  const companyFields = compactFields([
    field("Industry", account.industry),
    field("Website", account.website, { type: "link" }),
    field("City", account.city),
    field("State", account.state),
    field("Status", fmt(account.status, true), { type: "status", status: account.status }),
    field("Tier", fmt(account.tier, true)),
    field("Fleet size", account.fleetSize != null ? `${account.fleetSize} assets` : null),
    field("MRR", account.mrr != null ? `₹${account.mrr.toLocaleString("en-IN")} / month` : null),
    field("Internal notes", account.internalNotes, { wide: true }),
  ]);
  if (companyFields.length) sections.push({ id: "company", title: "Company", fields: companyFields });

  const contactFields = compactFields([
    field("Name", contact.name),
    field("Role", contact.role),
    field("Email", contact.email, { type: "email" }),
    field("Phone", contact.phone),
  ]);
  if (contactFields.length) sections.push({ id: "contact", title: "Primary contact", fields: contactFields });

  const salesFields = compactFields([
    field("Potential ACV", sp.potentialAcv ? `${sp.potentialAcv} L` : null),
    field("Owner", fmt(sp.owner, true)),
    field("Stage", fmt(sp.stage, true)),
    field("Lead status", fmt(sp.leadStatus, true)),
    field("Asset type", sp.assetType),
    field("Ecosystem role", sp.ecosystemRole),
    field("Last touch point", sp.lastTouchPoint),
    field("Next action", sp.nextAction),
    field("Expected close", sp.expectedClose),
    field("Solution required", sp.solutionRequired),
    field("Discussion comments", sp.discussionComments, { wide: true }),
  ]);
  if (salesFields.length) {
    sections.push({ id: "sales", title: "Sales pipeline", fields: salesFields, span: "full" });
  }

  const metaFields = compactFields([
    field("Created", account.createdAt),
    field("Updated", account.updatedAt),
  ]);
  if (metaFields.length) sections.push({ id: "meta", title: "Record", fields: metaFields });

  return sections;
}

export function accountDetailSubtitle(account) {
  return [
    [account.city, account.state].filter(Boolean).join(", "),
    account.tier,
    account.status,
  ].filter(Boolean).join(" · ");
}
